<template>
  <div class="p-4">

    <b-tabs card pills vertical v-model="tabIndex">
      <template #tabs-start>
        <li role="presentation" class="nav-item align-self-center mt-3 mb-3"><b>Horizon Europe InfoGraphics</b></li>
      </template>
      <b-tab title="Clusters / Destinations / Calls (Treemap) ">
          <InfoGraphicsTreemap></InfoGraphicsTreemap>
      </b-tab>
      <b-tab title="Budgets & Deadlines per Programme Part (Bubble Chart)">
        <InfoGraphicsBubbles></InfoGraphicsBubbles>
      </b-tab>
      <b-tab title="Deadlines Calendar (Temporal Heatmap)">
        <InfoGraphicsCalendar></InfoGraphicsCalendar>
      </b-tab>

      <!--
      <b-tab title="What topics have in common? (Chord diagram)">
        lorem
      </b-tab>
    -->
    </b-tabs>


  </div>
</template>

<script>
import InfoGraphicsTreemap from './InfoGraphicsTreemap'
import InfoGraphicsCalendar from './InfoGraphicsCalendar'
import InfoGraphicsBubbles from './InfoGraphicsBubbles'

export default {
  name: 'InfoGraphicsComponent',
  components: {
    InfoGraphicsTreemap,
    InfoGraphicsCalendar,
    InfoGraphicsBubbles
  },
  created: function () {
    if( this.$router.currentRoute.query && this.$router.currentRoute.query.tab ) {
      this.tabIndex = parseInt(this.$router.currentRoute.query.tab);
    }
  },
  computed: {

  },
  data() {
    return {
      tabIndex: 0,
      selectedNode: '',
      respondToRouteChanges: true,
    }
  },
  watch : {
    tabIndex: function (newTabIndex, oldTabIndex) {
      if( newTabIndex != oldTabIndex )
        this.changeRoute({query: { tab: newTabIndex } });
    }
  },
  methods: {

    changeRoute: function(route) {
      this.respondToRouteChanges = false;
      this.$router.push(route)
        .finally(() => {
              this.respondToRouteChanges = true;
            });
    }

  },
}

</script>

<style scoped>

</style>
